module.exports = __webpack_public_path__ + "static/security-733d8c53d82a4eeb2a23e2e85c52048b.svg";